// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: hubspotr.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "pc.proto.hubspotr";

/** Hubspot: 1=New, 2=Waiting on contact, 3=Waiting on us, 4=Closed */
export enum TicketState {
  STATE_UNKNOWN = 0,
  STATE_NEW = 1,
  STATE_WAIT_ON_CONTACT = 2,
  STATE_WAIT_ON_US = 3,
  STATE_WAIT_ON_DEV = 4,
  STATE_WAIT_ON_APPOINTMENT = 6,
  STATE_WAIT_ON_CLOSE = 7,
  STATE_CLOSED = 5,
  UNRECOGNIZED = -1,
}

export function ticketStateFromJSON(object: any): TicketState {
  switch (object) {
    case 0:
    case "STATE_UNKNOWN":
      return TicketState.STATE_UNKNOWN;
    case 1:
    case "STATE_NEW":
      return TicketState.STATE_NEW;
    case 2:
    case "STATE_WAIT_ON_CONTACT":
      return TicketState.STATE_WAIT_ON_CONTACT;
    case 3:
    case "STATE_WAIT_ON_US":
      return TicketState.STATE_WAIT_ON_US;
    case 4:
    case "STATE_WAIT_ON_DEV":
      return TicketState.STATE_WAIT_ON_DEV;
    case 6:
    case "STATE_WAIT_ON_APPOINTMENT":
      return TicketState.STATE_WAIT_ON_APPOINTMENT;
    case 7:
    case "STATE_WAIT_ON_CLOSE":
      return TicketState.STATE_WAIT_ON_CLOSE;
    case 5:
    case "STATE_CLOSED":
      return TicketState.STATE_CLOSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TicketState.UNRECOGNIZED;
  }
}

export function ticketStateToJSON(object: TicketState): string {
  switch (object) {
    case TicketState.STATE_UNKNOWN:
      return "STATE_UNKNOWN";
    case TicketState.STATE_NEW:
      return "STATE_NEW";
    case TicketState.STATE_WAIT_ON_CONTACT:
      return "STATE_WAIT_ON_CONTACT";
    case TicketState.STATE_WAIT_ON_US:
      return "STATE_WAIT_ON_US";
    case TicketState.STATE_WAIT_ON_DEV:
      return "STATE_WAIT_ON_DEV";
    case TicketState.STATE_WAIT_ON_APPOINTMENT:
      return "STATE_WAIT_ON_APPOINTMENT";
    case TicketState.STATE_WAIT_ON_CLOSE:
      return "STATE_WAIT_ON_CLOSE";
    case TicketState.STATE_CLOSED:
      return "STATE_CLOSED";
    case TicketState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Published by odoo: Must create or update a contact at hubspot */
export interface OdooContactDataEvent {
  /** 0 == no tenant assigned */
  odooTenantId: number;
  odooId: number;
  /** 0 == no parent company assigned yet */
  odooCompanyId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  /** ISO 639-1 language codes (e.g., "en", "es", "fr", "de") */
  language: string;
  hubspotId: string;
}

/** Published by hubspotr: A contact has been created at hubspot. Used to store hubspot id in odoo */
export interface HubspotContactCreatedEvent {
  odooId: number;
  hubspotId: string;
}

/** Published by odoo: Must create or update a company at hubspot */
export interface OdooCompanyDataEvent {
  odooTenantId: number;
  odooId: number;
  name: string;
  street: string;
  zip: string;
  city: string;
  /** Country code ISO 3166-1 alpha-2 (e.g., "DE", "US") */
  country: string;
  phone: string;
  domain: string;
  partnerLevel: string;
  /** ref field filled? */
  isCustomer: boolean;
  /** active affiliate present? */
  isPartner: boolean;
  /** field is_pc20_csp */
  isCsp: boolean;
  /** x_ref_supplier field filled? */
  isSupplier: boolean;
}

/** Published by hubspotr: A company has been created at hubspot. Used to store hubspot id in odoo */
export interface HubspotCompanyCreatedEvent {
  odooId: number;
  hubspotId: string;
}

/** Published by odoo: Must create or update a subscription at hubspot */
export interface OdooSubscriptionDataEvent {
  odooTenantId: number;
  odooId: number;
  odooCompanyId: number;
  /** owner => contact in the subscription */
  odooOwnerContactId: number;
  /** admin => reseller contact, if a reseller is present, else set to owner */
  odooAdminContactId: number;
  name: string;
  applianceName: string;
  /** net total */
  recurringAmount?: Money | undefined;
  subscriptionState: OdooSubscriptionDataEvent_SubscriptionState;
  type: string;
  /** subscription start date in format YYYY-MM-DD */
  dateStart: string;
  /** subscription end date in format YYYY-MM-DD */
  dateEnd: string;
}

export enum OdooSubscriptionDataEvent_SubscriptionState {
  UNKNOWN = 0,
  IN_PROGRESS = 1,
  CLOSED = 2,
  UNRECOGNIZED = -1,
}

export function odooSubscriptionDataEvent_SubscriptionStateFromJSON(
  object: any,
): OdooSubscriptionDataEvent_SubscriptionState {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return OdooSubscriptionDataEvent_SubscriptionState.UNKNOWN;
    case 1:
    case "IN_PROGRESS":
      return OdooSubscriptionDataEvent_SubscriptionState.IN_PROGRESS;
    case 2:
    case "CLOSED":
      return OdooSubscriptionDataEvent_SubscriptionState.CLOSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OdooSubscriptionDataEvent_SubscriptionState.UNRECOGNIZED;
  }
}

export function odooSubscriptionDataEvent_SubscriptionStateToJSON(
  object: OdooSubscriptionDataEvent_SubscriptionState,
): string {
  switch (object) {
    case OdooSubscriptionDataEvent_SubscriptionState.UNKNOWN:
      return "UNKNOWN";
    case OdooSubscriptionDataEvent_SubscriptionState.IN_PROGRESS:
      return "IN_PROGRESS";
    case OdooSubscriptionDataEvent_SubscriptionState.CLOSED:
      return "CLOSED";
    case OdooSubscriptionDataEvent_SubscriptionState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** A subscription has been created in hubspot and the hubspot id needs to be synced back to odoo */
export interface HubspotSubscriptionCreatedEvent {
  odooId: number;
  hubspotId: string;
}

/** Represents an amount of money with its currency type. */
export interface Money {
  /** The three-letter currency code defined in ISO 4217. */
  currencyCode: string;
  /** amount, e.g. 1000500.799 or -100.50 */
  amount: number;
}

/** Attachment prepared for upload - hubspotr receives resolved download URLs */
export interface PreparedTicketAttachment {
  downloadUrl: string;
  filename: string;
}

/** Attachment stored in HubSpot */
export interface PersistedTicketAttachment {
  fileId: string;
  fileName: string;
}

/**
 * Creates a new ticket via HubSpot conversation.
 * mypascom BE must verify appliance access and resolve instance_name before calling this.
 * hubspotr resolves instance_name -> subscription for the conversation header.
 */
export interface CreateTicketRequest {
  contactEmail: string;
  instanceName: string;
  title: string;
  body: string;
  sla: string;
  attachments: PreparedTicketAttachment[];
  applianceId: number;
}

export interface CreateTicketResponse {
  outcome: CreateTicketResponse_Outcome;
  /** our opaque thread ID (pascom_thread_id) */
  threadId: string;
}

export enum CreateTicketResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function createTicketResponse_OutcomeFromJSON(object: any): CreateTicketResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return CreateTicketResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return CreateTicketResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return CreateTicketResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CreateTicketResponse_Outcome.UNRECOGNIZED;
  }
}

export function createTicketResponse_OutcomeToJSON(object: CreateTicketResponse_Outcome): string {
  switch (object) {
    case CreateTicketResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case CreateTicketResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case CreateTicketResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case CreateTicketResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Used to fetch all tickets linked to the given appliance IDs.
 * mypascom BE must resolve the user's accessible appliance IDs before calling this.
 */
export interface GetTicketListRequest {
  applianceIds: number[];
  /** used to filter the result by state */
  includeTicketStates: TicketState[];
}

export interface GetTicketListResponse {
  outcome: GetTicketListResponse_Outcome;
  slimTickets: SlimTicket[];
}

export enum GetTicketListResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function getTicketListResponse_OutcomeFromJSON(object: any): GetTicketListResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return GetTicketListResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return GetTicketListResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return GetTicketListResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetTicketListResponse_Outcome.UNRECOGNIZED;
  }
}

export function getTicketListResponse_OutcomeToJSON(object: GetTicketListResponse_Outcome): string {
  switch (object) {
    case GetTicketListResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case GetTicketListResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case GetTicketListResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case GetTicketListResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** High level representation of a Ticket. Usually used in list views for a first display */
export interface SlimTicket {
  threadId: string;
  ticketId: string;
  title: string;
  applianceName: string;
  applianceId: number;
  state: TicketState;
  createdAt: number;
}

/** Get download URL for ticket attachment */
export interface GetTicketAttachmentDownloadUrlRequest {
  fileId: string;
  threadId: string;
}

export interface GetTicketAttachmentDownloadUrlResponse {
  downloadUrl: string;
}

/** Used for a permission check between mypascom BE and hubspotr */
export interface VerifyTicketAccessRequest {
  threadId: string;
  applianceIds: number[];
}

export interface VerifyTicketAccessResponse {
  outcome: VerifyTicketAccessResponse_Outcome;
}

export enum VerifyTicketAccessResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_ACCESS_GRANTED = 1,
  OUTCOME_FORBIDDEN = 2,
  OUTCOME_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function verifyTicketAccessResponse_OutcomeFromJSON(object: any): VerifyTicketAccessResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return VerifyTicketAccessResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_ACCESS_GRANTED":
      return VerifyTicketAccessResponse_Outcome.OUTCOME_ACCESS_GRANTED;
    case 2:
    case "OUTCOME_FORBIDDEN":
      return VerifyTicketAccessResponse_Outcome.OUTCOME_FORBIDDEN;
    case 3:
    case "OUTCOME_ERROR":
      return VerifyTicketAccessResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VerifyTicketAccessResponse_Outcome.UNRECOGNIZED;
  }
}

export function verifyTicketAccessResponse_OutcomeToJSON(object: VerifyTicketAccessResponse_Outcome): string {
  switch (object) {
    case VerifyTicketAccessResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case VerifyTicketAccessResponse_Outcome.OUTCOME_ACCESS_GRANTED:
      return "OUTCOME_ACCESS_GRANTED";
    case VerifyTicketAccessResponse_Outcome.OUTCOME_FORBIDDEN:
      return "OUTCOME_FORBIDDEN";
    case VerifyTicketAccessResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case VerifyTicketAccessResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Add a text message to a ticket conversation */
export interface AddMessageConversationEntryRequest {
  threadId: string;
  senderEmail: string;
  body: string;
  attachments: PreparedTicketAttachment[];
}

export interface AddMessageConversationEntryResponse {
  outcome: AddMessageConversationEntryResponse_Outcome;
}

export enum AddMessageConversationEntryResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function addMessageConversationEntryResponse_OutcomeFromJSON(
  object: any,
): AddMessageConversationEntryResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return AddMessageConversationEntryResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return AddMessageConversationEntryResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return AddMessageConversationEntryResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AddMessageConversationEntryResponse_Outcome.UNRECOGNIZED;
  }
}

export function addMessageConversationEntryResponse_OutcomeToJSON(
  object: AddMessageConversationEntryResponse_Outcome,
): string {
  switch (object) {
    case AddMessageConversationEntryResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case AddMessageConversationEntryResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case AddMessageConversationEntryResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case AddMessageConversationEntryResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Change ticket state */
export interface CloseTicketRequest {
  threadId: string;
}

export interface CloseTicketResponse {
  outcome: CloseTicketResponse_Outcome;
}

export enum CloseTicketResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function closeTicketResponse_OutcomeFromJSON(object: any): CloseTicketResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return CloseTicketResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return CloseTicketResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return CloseTicketResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CloseTicketResponse_Outcome.UNRECOGNIZED;
  }
}

export function closeTicketResponse_OutcomeToJSON(object: CloseTicketResponse_Outcome): string {
  switch (object) {
    case CloseTicketResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case CloseTicketResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case CloseTicketResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case CloseTicketResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Detailed representation of a Ticket. Contains all interactions between pascom <-> customer within this ticket */
export interface DetailedTicket {
  threadId: string;
  ticketId: string;
  applianceName: string;
  applianceId: number;
  title: string;
  state: TicketState;
  createdAt: number;
  /**
   * the actual list of "events", which happened for this ticket,
   * e.g. a message from the customer to pascom and vice versa, a status change, ...
   */
  conversationEntries: DetailedTicket_ConversationEntry[];
}

export interface DetailedTicket_ConversationEntry {
  /**
   * There might be different kind of conversation entries, not only text messages.
   * For example, ticket status changes
   */
  entry?: {
    $case: "messageConversationEntry";
    messageConversationEntry: DetailedTicket_ConversationEntry_MessageConversationEntry;
  } | undefined;
}

export enum DetailedTicket_ConversationEntry_Direction {
  DIRECTION_UNKNOWN = 0,
  /** DIRECTION_OUTGOING - pascom -> customer */
  DIRECTION_OUTGOING = 1,
  /** DIRECTION_INCOMING - customer -> pascom */
  DIRECTION_INCOMING = 2,
  UNRECOGNIZED = -1,
}

export function detailedTicket_ConversationEntry_DirectionFromJSON(
  object: any,
): DetailedTicket_ConversationEntry_Direction {
  switch (object) {
    case 0:
    case "DIRECTION_UNKNOWN":
      return DetailedTicket_ConversationEntry_Direction.DIRECTION_UNKNOWN;
    case 1:
    case "DIRECTION_OUTGOING":
      return DetailedTicket_ConversationEntry_Direction.DIRECTION_OUTGOING;
    case 2:
    case "DIRECTION_INCOMING":
      return DetailedTicket_ConversationEntry_Direction.DIRECTION_INCOMING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DetailedTicket_ConversationEntry_Direction.UNRECOGNIZED;
  }
}

export function detailedTicket_ConversationEntry_DirectionToJSON(
  object: DetailedTicket_ConversationEntry_Direction,
): string {
  switch (object) {
    case DetailedTicket_ConversationEntry_Direction.DIRECTION_UNKNOWN:
      return "DIRECTION_UNKNOWN";
    case DetailedTicket_ConversationEntry_Direction.DIRECTION_OUTGOING:
      return "DIRECTION_OUTGOING";
    case DetailedTicket_ConversationEntry_Direction.DIRECTION_INCOMING:
      return "DIRECTION_INCOMING";
    case DetailedTicket_ConversationEntry_Direction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DetailedTicket_ConversationEntry_MessageConversationEntry {
  text: string;
  senderEmail: string;
  senderName: string;
  attachments: PersistedTicketAttachment[];
  direction: DetailedTicket_ConversationEntry_Direction;
  createdAt: number;
}

/** Get full ticket details including conversation */
export interface GetTicketDetailRequest {
  threadId: string;
}

export interface GetTicketDetailResponse {
  outcome: GetTicketDetailResponse_Outcome;
  detailedTicket?: DetailedTicket | undefined;
}

export enum GetTicketDetailResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function getTicketDetailResponse_OutcomeFromJSON(object: any): GetTicketDetailResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return GetTicketDetailResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return GetTicketDetailResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return GetTicketDetailResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetTicketDetailResponse_Outcome.UNRECOGNIZED;
  }
}

export function getTicketDetailResponse_OutcomeToJSON(object: GetTicketDetailResponse_Outcome): string {
  switch (object) {
    case GetTicketDetailResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case GetTicketDetailResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case GetTicketDetailResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case GetTicketDetailResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseOdooContactDataEvent(): OdooContactDataEvent {
  return {
    odooTenantId: 0,
    odooId: 0,
    odooCompanyId: 0,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    language: "",
    hubspotId: "",
  };
}

export const OdooContactDataEvent: MessageFns<OdooContactDataEvent> = {
  encode(message: OdooContactDataEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.odooTenantId !== 0) {
      writer.uint32(8).uint64(message.odooTenantId);
    }
    if (message.odooId !== 0) {
      writer.uint32(16).uint64(message.odooId);
    }
    if (message.odooCompanyId !== 0) {
      writer.uint32(24).uint64(message.odooCompanyId);
    }
    if (message.firstName !== "") {
      writer.uint32(34).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(42).string(message.lastName);
    }
    if (message.email !== "") {
      writer.uint32(50).string(message.email);
    }
    if (message.phone !== "") {
      writer.uint32(58).string(message.phone);
    }
    if (message.language !== "") {
      writer.uint32(66).string(message.language);
    }
    if (message.hubspotId !== "") {
      writer.uint32(74).string(message.hubspotId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OdooContactDataEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOdooContactDataEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.odooTenantId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.odooId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.odooCompanyId = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.firstName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.lastName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.phone = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.language = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.hubspotId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OdooContactDataEvent {
    return {
      odooTenantId: isSet(object.odooTenantId) ? globalThis.Number(object.odooTenantId) : 0,
      odooId: isSet(object.odooId) ? globalThis.Number(object.odooId) : 0,
      odooCompanyId: isSet(object.odooCompanyId) ? globalThis.Number(object.odooCompanyId) : 0,
      firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : "",
      lastName: isSet(object.lastName) ? globalThis.String(object.lastName) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      language: isSet(object.language) ? globalThis.String(object.language) : "",
      hubspotId: isSet(object.hubspotId) ? globalThis.String(object.hubspotId) : "",
    };
  },

  toJSON(message: OdooContactDataEvent): unknown {
    const obj: any = {};
    if (message.odooTenantId !== 0) {
      obj.odooTenantId = Math.round(message.odooTenantId);
    }
    if (message.odooId !== 0) {
      obj.odooId = Math.round(message.odooId);
    }
    if (message.odooCompanyId !== 0) {
      obj.odooCompanyId = Math.round(message.odooCompanyId);
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.language !== "") {
      obj.language = message.language;
    }
    if (message.hubspotId !== "") {
      obj.hubspotId = message.hubspotId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OdooContactDataEvent>, I>>(base?: I): OdooContactDataEvent {
    return OdooContactDataEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OdooContactDataEvent>, I>>(object: I): OdooContactDataEvent {
    const message = createBaseOdooContactDataEvent();
    message.odooTenantId = object.odooTenantId ?? 0;
    message.odooId = object.odooId ?? 0;
    message.odooCompanyId = object.odooCompanyId ?? 0;
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.email = object.email ?? "";
    message.phone = object.phone ?? "";
    message.language = object.language ?? "";
    message.hubspotId = object.hubspotId ?? "";
    return message;
  },
};

function createBaseHubspotContactCreatedEvent(): HubspotContactCreatedEvent {
  return { odooId: 0, hubspotId: "" };
}

export const HubspotContactCreatedEvent: MessageFns<HubspotContactCreatedEvent> = {
  encode(message: HubspotContactCreatedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.odooId !== 0) {
      writer.uint32(8).uint64(message.odooId);
    }
    if (message.hubspotId !== "") {
      writer.uint32(18).string(message.hubspotId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HubspotContactCreatedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHubspotContactCreatedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.odooId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hubspotId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HubspotContactCreatedEvent {
    return {
      odooId: isSet(object.odooId) ? globalThis.Number(object.odooId) : 0,
      hubspotId: isSet(object.hubspotId) ? globalThis.String(object.hubspotId) : "",
    };
  },

  toJSON(message: HubspotContactCreatedEvent): unknown {
    const obj: any = {};
    if (message.odooId !== 0) {
      obj.odooId = Math.round(message.odooId);
    }
    if (message.hubspotId !== "") {
      obj.hubspotId = message.hubspotId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HubspotContactCreatedEvent>, I>>(base?: I): HubspotContactCreatedEvent {
    return HubspotContactCreatedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HubspotContactCreatedEvent>, I>>(object: I): HubspotContactCreatedEvent {
    const message = createBaseHubspotContactCreatedEvent();
    message.odooId = object.odooId ?? 0;
    message.hubspotId = object.hubspotId ?? "";
    return message;
  },
};

function createBaseOdooCompanyDataEvent(): OdooCompanyDataEvent {
  return {
    odooTenantId: 0,
    odooId: 0,
    name: "",
    street: "",
    zip: "",
    city: "",
    country: "",
    phone: "",
    domain: "",
    partnerLevel: "",
    isCustomer: false,
    isPartner: false,
    isCsp: false,
    isSupplier: false,
  };
}

export const OdooCompanyDataEvent: MessageFns<OdooCompanyDataEvent> = {
  encode(message: OdooCompanyDataEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.odooTenantId !== 0) {
      writer.uint32(8).uint64(message.odooTenantId);
    }
    if (message.odooId !== 0) {
      writer.uint32(16).uint64(message.odooId);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.street !== "") {
      writer.uint32(42).string(message.street);
    }
    if (message.zip !== "") {
      writer.uint32(50).string(message.zip);
    }
    if (message.city !== "") {
      writer.uint32(58).string(message.city);
    }
    if (message.country !== "") {
      writer.uint32(66).string(message.country);
    }
    if (message.phone !== "") {
      writer.uint32(74).string(message.phone);
    }
    if (message.domain !== "") {
      writer.uint32(82).string(message.domain);
    }
    if (message.partnerLevel !== "") {
      writer.uint32(90).string(message.partnerLevel);
    }
    if (message.isCustomer !== false) {
      writer.uint32(96).bool(message.isCustomer);
    }
    if (message.isPartner !== false) {
      writer.uint32(104).bool(message.isPartner);
    }
    if (message.isCsp !== false) {
      writer.uint32(112).bool(message.isCsp);
    }
    if (message.isSupplier !== false) {
      writer.uint32(120).bool(message.isSupplier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OdooCompanyDataEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOdooCompanyDataEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.odooTenantId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.odooId = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.street = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.zip = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.phone = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.domain = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.partnerLevel = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isCustomer = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isPartner = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.isCsp = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.isSupplier = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OdooCompanyDataEvent {
    return {
      odooTenantId: isSet(object.odooTenantId) ? globalThis.Number(object.odooTenantId) : 0,
      odooId: isSet(object.odooId) ? globalThis.Number(object.odooId) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      street: isSet(object.street) ? globalThis.String(object.street) : "",
      zip: isSet(object.zip) ? globalThis.String(object.zip) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      domain: isSet(object.domain) ? globalThis.String(object.domain) : "",
      partnerLevel: isSet(object.partnerLevel) ? globalThis.String(object.partnerLevel) : "",
      isCustomer: isSet(object.isCustomer) ? globalThis.Boolean(object.isCustomer) : false,
      isPartner: isSet(object.isPartner) ? globalThis.Boolean(object.isPartner) : false,
      isCsp: isSet(object.isCsp) ? globalThis.Boolean(object.isCsp) : false,
      isSupplier: isSet(object.isSupplier) ? globalThis.Boolean(object.isSupplier) : false,
    };
  },

  toJSON(message: OdooCompanyDataEvent): unknown {
    const obj: any = {};
    if (message.odooTenantId !== 0) {
      obj.odooTenantId = Math.round(message.odooTenantId);
    }
    if (message.odooId !== 0) {
      obj.odooId = Math.round(message.odooId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.street !== "") {
      obj.street = message.street;
    }
    if (message.zip !== "") {
      obj.zip = message.zip;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.domain !== "") {
      obj.domain = message.domain;
    }
    if (message.partnerLevel !== "") {
      obj.partnerLevel = message.partnerLevel;
    }
    if (message.isCustomer !== false) {
      obj.isCustomer = message.isCustomer;
    }
    if (message.isPartner !== false) {
      obj.isPartner = message.isPartner;
    }
    if (message.isCsp !== false) {
      obj.isCsp = message.isCsp;
    }
    if (message.isSupplier !== false) {
      obj.isSupplier = message.isSupplier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OdooCompanyDataEvent>, I>>(base?: I): OdooCompanyDataEvent {
    return OdooCompanyDataEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OdooCompanyDataEvent>, I>>(object: I): OdooCompanyDataEvent {
    const message = createBaseOdooCompanyDataEvent();
    message.odooTenantId = object.odooTenantId ?? 0;
    message.odooId = object.odooId ?? 0;
    message.name = object.name ?? "";
    message.street = object.street ?? "";
    message.zip = object.zip ?? "";
    message.city = object.city ?? "";
    message.country = object.country ?? "";
    message.phone = object.phone ?? "";
    message.domain = object.domain ?? "";
    message.partnerLevel = object.partnerLevel ?? "";
    message.isCustomer = object.isCustomer ?? false;
    message.isPartner = object.isPartner ?? false;
    message.isCsp = object.isCsp ?? false;
    message.isSupplier = object.isSupplier ?? false;
    return message;
  },
};

function createBaseHubspotCompanyCreatedEvent(): HubspotCompanyCreatedEvent {
  return { odooId: 0, hubspotId: "" };
}

export const HubspotCompanyCreatedEvent: MessageFns<HubspotCompanyCreatedEvent> = {
  encode(message: HubspotCompanyCreatedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.odooId !== 0) {
      writer.uint32(8).uint64(message.odooId);
    }
    if (message.hubspotId !== "") {
      writer.uint32(18).string(message.hubspotId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HubspotCompanyCreatedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHubspotCompanyCreatedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.odooId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hubspotId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HubspotCompanyCreatedEvent {
    return {
      odooId: isSet(object.odooId) ? globalThis.Number(object.odooId) : 0,
      hubspotId: isSet(object.hubspotId) ? globalThis.String(object.hubspotId) : "",
    };
  },

  toJSON(message: HubspotCompanyCreatedEvent): unknown {
    const obj: any = {};
    if (message.odooId !== 0) {
      obj.odooId = Math.round(message.odooId);
    }
    if (message.hubspotId !== "") {
      obj.hubspotId = message.hubspotId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HubspotCompanyCreatedEvent>, I>>(base?: I): HubspotCompanyCreatedEvent {
    return HubspotCompanyCreatedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HubspotCompanyCreatedEvent>, I>>(object: I): HubspotCompanyCreatedEvent {
    const message = createBaseHubspotCompanyCreatedEvent();
    message.odooId = object.odooId ?? 0;
    message.hubspotId = object.hubspotId ?? "";
    return message;
  },
};

function createBaseOdooSubscriptionDataEvent(): OdooSubscriptionDataEvent {
  return {
    odooTenantId: 0,
    odooId: 0,
    odooCompanyId: 0,
    odooOwnerContactId: 0,
    odooAdminContactId: 0,
    name: "",
    applianceName: "",
    recurringAmount: undefined,
    subscriptionState: 0,
    type: "",
    dateStart: "",
    dateEnd: "",
  };
}

export const OdooSubscriptionDataEvent: MessageFns<OdooSubscriptionDataEvent> = {
  encode(message: OdooSubscriptionDataEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.odooTenantId !== 0) {
      writer.uint32(8).uint64(message.odooTenantId);
    }
    if (message.odooId !== 0) {
      writer.uint32(16).uint64(message.odooId);
    }
    if (message.odooCompanyId !== 0) {
      writer.uint32(32).uint64(message.odooCompanyId);
    }
    if (message.odooOwnerContactId !== 0) {
      writer.uint32(48).uint64(message.odooOwnerContactId);
    }
    if (message.odooAdminContactId !== 0) {
      writer.uint32(64).uint64(message.odooAdminContactId);
    }
    if (message.name !== "") {
      writer.uint32(82).string(message.name);
    }
    if (message.applianceName !== "") {
      writer.uint32(90).string(message.applianceName);
    }
    if (message.recurringAmount !== undefined) {
      Money.encode(message.recurringAmount, writer.uint32(98).fork()).join();
    }
    if (message.subscriptionState !== 0) {
      writer.uint32(104).int32(message.subscriptionState);
    }
    if (message.type !== "") {
      writer.uint32(114).string(message.type);
    }
    if (message.dateStart !== "") {
      writer.uint32(122).string(message.dateStart);
    }
    if (message.dateEnd !== "") {
      writer.uint32(130).string(message.dateEnd);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OdooSubscriptionDataEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOdooSubscriptionDataEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.odooTenantId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.odooId = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.odooCompanyId = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.odooOwnerContactId = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.odooAdminContactId = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.applianceName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.recurringAmount = Money.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.subscriptionState = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.dateStart = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.dateEnd = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OdooSubscriptionDataEvent {
    return {
      odooTenantId: isSet(object.odooTenantId) ? globalThis.Number(object.odooTenantId) : 0,
      odooId: isSet(object.odooId) ? globalThis.Number(object.odooId) : 0,
      odooCompanyId: isSet(object.odooCompanyId) ? globalThis.Number(object.odooCompanyId) : 0,
      odooOwnerContactId: isSet(object.odooOwnerContactId) ? globalThis.Number(object.odooOwnerContactId) : 0,
      odooAdminContactId: isSet(object.odooAdminContactId) ? globalThis.Number(object.odooAdminContactId) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      applianceName: isSet(object.applianceName) ? globalThis.String(object.applianceName) : "",
      recurringAmount: isSet(object.recurringAmount) ? Money.fromJSON(object.recurringAmount) : undefined,
      subscriptionState: isSet(object.subscriptionState)
        ? odooSubscriptionDataEvent_SubscriptionStateFromJSON(object.subscriptionState)
        : 0,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      dateStart: isSet(object.dateStart) ? globalThis.String(object.dateStart) : "",
      dateEnd: isSet(object.dateEnd) ? globalThis.String(object.dateEnd) : "",
    };
  },

  toJSON(message: OdooSubscriptionDataEvent): unknown {
    const obj: any = {};
    if (message.odooTenantId !== 0) {
      obj.odooTenantId = Math.round(message.odooTenantId);
    }
    if (message.odooId !== 0) {
      obj.odooId = Math.round(message.odooId);
    }
    if (message.odooCompanyId !== 0) {
      obj.odooCompanyId = Math.round(message.odooCompanyId);
    }
    if (message.odooOwnerContactId !== 0) {
      obj.odooOwnerContactId = Math.round(message.odooOwnerContactId);
    }
    if (message.odooAdminContactId !== 0) {
      obj.odooAdminContactId = Math.round(message.odooAdminContactId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.applianceName !== "") {
      obj.applianceName = message.applianceName;
    }
    if (message.recurringAmount !== undefined) {
      obj.recurringAmount = Money.toJSON(message.recurringAmount);
    }
    if (message.subscriptionState !== 0) {
      obj.subscriptionState = odooSubscriptionDataEvent_SubscriptionStateToJSON(message.subscriptionState);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.dateStart !== "") {
      obj.dateStart = message.dateStart;
    }
    if (message.dateEnd !== "") {
      obj.dateEnd = message.dateEnd;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OdooSubscriptionDataEvent>, I>>(base?: I): OdooSubscriptionDataEvent {
    return OdooSubscriptionDataEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OdooSubscriptionDataEvent>, I>>(object: I): OdooSubscriptionDataEvent {
    const message = createBaseOdooSubscriptionDataEvent();
    message.odooTenantId = object.odooTenantId ?? 0;
    message.odooId = object.odooId ?? 0;
    message.odooCompanyId = object.odooCompanyId ?? 0;
    message.odooOwnerContactId = object.odooOwnerContactId ?? 0;
    message.odooAdminContactId = object.odooAdminContactId ?? 0;
    message.name = object.name ?? "";
    message.applianceName = object.applianceName ?? "";
    message.recurringAmount = (object.recurringAmount !== undefined && object.recurringAmount !== null)
      ? Money.fromPartial(object.recurringAmount)
      : undefined;
    message.subscriptionState = object.subscriptionState ?? 0;
    message.type = object.type ?? "";
    message.dateStart = object.dateStart ?? "";
    message.dateEnd = object.dateEnd ?? "";
    return message;
  },
};

function createBaseHubspotSubscriptionCreatedEvent(): HubspotSubscriptionCreatedEvent {
  return { odooId: 0, hubspotId: "" };
}

export const HubspotSubscriptionCreatedEvent: MessageFns<HubspotSubscriptionCreatedEvent> = {
  encode(message: HubspotSubscriptionCreatedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.odooId !== 0) {
      writer.uint32(8).uint64(message.odooId);
    }
    if (message.hubspotId !== "") {
      writer.uint32(18).string(message.hubspotId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HubspotSubscriptionCreatedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHubspotSubscriptionCreatedEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.odooId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hubspotId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HubspotSubscriptionCreatedEvent {
    return {
      odooId: isSet(object.odooId) ? globalThis.Number(object.odooId) : 0,
      hubspotId: isSet(object.hubspotId) ? globalThis.String(object.hubspotId) : "",
    };
  },

  toJSON(message: HubspotSubscriptionCreatedEvent): unknown {
    const obj: any = {};
    if (message.odooId !== 0) {
      obj.odooId = Math.round(message.odooId);
    }
    if (message.hubspotId !== "") {
      obj.hubspotId = message.hubspotId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HubspotSubscriptionCreatedEvent>, I>>(base?: I): HubspotSubscriptionCreatedEvent {
    return HubspotSubscriptionCreatedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HubspotSubscriptionCreatedEvent>, I>>(
    object: I,
  ): HubspotSubscriptionCreatedEvent {
    const message = createBaseHubspotSubscriptionCreatedEvent();
    message.odooId = object.odooId ?? 0;
    message.hubspotId = object.hubspotId ?? "";
    return message;
  },
};

function createBaseMoney(): Money {
  return { currencyCode: "", amount: 0 };
}

export const Money: MessageFns<Money> = {
  encode(message: Money, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currencyCode !== "") {
      writer.uint32(10).string(message.currencyCode);
    }
    if (message.amount !== 0) {
      writer.uint32(17).double(message.amount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Money {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoney();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.currencyCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.amount = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Money {
    return {
      currencyCode: isSet(object.currencyCode) ? globalThis.String(object.currencyCode) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
    };
  },

  toJSON(message: Money): unknown {
    const obj: any = {};
    if (message.currencyCode !== "") {
      obj.currencyCode = message.currencyCode;
    }
    if (message.amount !== 0) {
      obj.amount = message.amount;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Money>, I>>(base?: I): Money {
    return Money.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Money>, I>>(object: I): Money {
    const message = createBaseMoney();
    message.currencyCode = object.currencyCode ?? "";
    message.amount = object.amount ?? 0;
    return message;
  },
};

function createBasePreparedTicketAttachment(): PreparedTicketAttachment {
  return { downloadUrl: "", filename: "" };
}

export const PreparedTicketAttachment: MessageFns<PreparedTicketAttachment> = {
  encode(message: PreparedTicketAttachment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.downloadUrl !== "") {
      writer.uint32(10).string(message.downloadUrl);
    }
    if (message.filename !== "") {
      writer.uint32(18).string(message.filename);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreparedTicketAttachment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreparedTicketAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.downloadUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreparedTicketAttachment {
    return {
      downloadUrl: isSet(object.downloadUrl) ? globalThis.String(object.downloadUrl) : "",
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
    };
  },

  toJSON(message: PreparedTicketAttachment): unknown {
    const obj: any = {};
    if (message.downloadUrl !== "") {
      obj.downloadUrl = message.downloadUrl;
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreparedTicketAttachment>, I>>(base?: I): PreparedTicketAttachment {
    return PreparedTicketAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreparedTicketAttachment>, I>>(object: I): PreparedTicketAttachment {
    const message = createBasePreparedTicketAttachment();
    message.downloadUrl = object.downloadUrl ?? "";
    message.filename = object.filename ?? "";
    return message;
  },
};

function createBasePersistedTicketAttachment(): PersistedTicketAttachment {
  return { fileId: "", fileName: "" };
}

export const PersistedTicketAttachment: MessageFns<PersistedTicketAttachment> = {
  encode(message: PersistedTicketAttachment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.fileName !== "") {
      writer.uint32(18).string(message.fileName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PersistedTicketAttachment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersistedTicketAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PersistedTicketAttachment {
    return {
      fileId: isSet(object.fileId) ? globalThis.String(object.fileId) : "",
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
    };
  },

  toJSON(message: PersistedTicketAttachment): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PersistedTicketAttachment>, I>>(base?: I): PersistedTicketAttachment {
    return PersistedTicketAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PersistedTicketAttachment>, I>>(object: I): PersistedTicketAttachment {
    const message = createBasePersistedTicketAttachment();
    message.fileId = object.fileId ?? "";
    message.fileName = object.fileName ?? "";
    return message;
  },
};

function createBaseCreateTicketRequest(): CreateTicketRequest {
  return { contactEmail: "", instanceName: "", title: "", body: "", sla: "", attachments: [], applianceId: 0 };
}

export const CreateTicketRequest: MessageFns<CreateTicketRequest> = {
  encode(message: CreateTicketRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.contactEmail !== "") {
      writer.uint32(10).string(message.contactEmail);
    }
    if (message.instanceName !== "") {
      writer.uint32(18).string(message.instanceName);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.body !== "") {
      writer.uint32(34).string(message.body);
    }
    if (message.sla !== "") {
      writer.uint32(42).string(message.sla);
    }
    for (const v of message.attachments) {
      PreparedTicketAttachment.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.applianceId !== 0) {
      writer.uint32(56).uint64(message.applianceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTicketRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTicketRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.contactEmail = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.instanceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sla = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.attachments.push(PreparedTicketAttachment.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTicketRequest {
    return {
      contactEmail: isSet(object.contactEmail) ? globalThis.String(object.contactEmail) : "",
      instanceName: isSet(object.instanceName) ? globalThis.String(object.instanceName) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      sla: isSet(object.sla) ? globalThis.String(object.sla) : "",
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => PreparedTicketAttachment.fromJSON(e))
        : [],
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
    };
  },

  toJSON(message: CreateTicketRequest): unknown {
    const obj: any = {};
    if (message.contactEmail !== "") {
      obj.contactEmail = message.contactEmail;
    }
    if (message.instanceName !== "") {
      obj.instanceName = message.instanceName;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.sla !== "") {
      obj.sla = message.sla;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => PreparedTicketAttachment.toJSON(e));
    }
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateTicketRequest>, I>>(base?: I): CreateTicketRequest {
    return CreateTicketRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateTicketRequest>, I>>(object: I): CreateTicketRequest {
    const message = createBaseCreateTicketRequest();
    message.contactEmail = object.contactEmail ?? "";
    message.instanceName = object.instanceName ?? "";
    message.title = object.title ?? "";
    message.body = object.body ?? "";
    message.sla = object.sla ?? "";
    message.attachments = object.attachments?.map((e) => PreparedTicketAttachment.fromPartial(e)) || [];
    message.applianceId = object.applianceId ?? 0;
    return message;
  },
};

function createBaseCreateTicketResponse(): CreateTicketResponse {
  return { outcome: 0, threadId: "" };
}

export const CreateTicketResponse: MessageFns<CreateTicketResponse> = {
  encode(message: CreateTicketResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.threadId !== "") {
      writer.uint32(18).string(message.threadId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTicketResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTicketResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTicketResponse {
    return {
      outcome: isSet(object.outcome) ? createTicketResponse_OutcomeFromJSON(object.outcome) : 0,
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
    };
  },

  toJSON(message: CreateTicketResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = createTicketResponse_OutcomeToJSON(message.outcome);
    }
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateTicketResponse>, I>>(base?: I): CreateTicketResponse {
    return CreateTicketResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateTicketResponse>, I>>(object: I): CreateTicketResponse {
    const message = createBaseCreateTicketResponse();
    message.outcome = object.outcome ?? 0;
    message.threadId = object.threadId ?? "";
    return message;
  },
};

function createBaseGetTicketListRequest(): GetTicketListRequest {
  return { applianceIds: [], includeTicketStates: [] };
}

export const GetTicketListRequest: MessageFns<GetTicketListRequest> = {
  encode(message: GetTicketListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.applianceIds) {
      writer.uint64(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.includeTicketStates) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTicketListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTicketListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.applianceIds.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.applianceIds.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 16) {
            message.includeTicketStates.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.includeTicketStates.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTicketListRequest {
    return {
      applianceIds: globalThis.Array.isArray(object?.applianceIds)
        ? object.applianceIds.map((e: any) => globalThis.Number(e))
        : [],
      includeTicketStates: globalThis.Array.isArray(object?.includeTicketStates)
        ? object.includeTicketStates.map((e: any) => ticketStateFromJSON(e))
        : [],
    };
  },

  toJSON(message: GetTicketListRequest): unknown {
    const obj: any = {};
    if (message.applianceIds?.length) {
      obj.applianceIds = message.applianceIds.map((e) => Math.round(e));
    }
    if (message.includeTicketStates?.length) {
      obj.includeTicketStates = message.includeTicketStates.map((e) => ticketStateToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTicketListRequest>, I>>(base?: I): GetTicketListRequest {
    return GetTicketListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTicketListRequest>, I>>(object: I): GetTicketListRequest {
    const message = createBaseGetTicketListRequest();
    message.applianceIds = object.applianceIds?.map((e) => e) || [];
    message.includeTicketStates = object.includeTicketStates?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetTicketListResponse(): GetTicketListResponse {
  return { outcome: 0, slimTickets: [] };
}

export const GetTicketListResponse: MessageFns<GetTicketListResponse> = {
  encode(message: GetTicketListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    for (const v of message.slimTickets) {
      SlimTicket.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTicketListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTicketListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.slimTickets.push(SlimTicket.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTicketListResponse {
    return {
      outcome: isSet(object.outcome) ? getTicketListResponse_OutcomeFromJSON(object.outcome) : 0,
      slimTickets: globalThis.Array.isArray(object?.slimTickets)
        ? object.slimTickets.map((e: any) => SlimTicket.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetTicketListResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = getTicketListResponse_OutcomeToJSON(message.outcome);
    }
    if (message.slimTickets?.length) {
      obj.slimTickets = message.slimTickets.map((e) => SlimTicket.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTicketListResponse>, I>>(base?: I): GetTicketListResponse {
    return GetTicketListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTicketListResponse>, I>>(object: I): GetTicketListResponse {
    const message = createBaseGetTicketListResponse();
    message.outcome = object.outcome ?? 0;
    message.slimTickets = object.slimTickets?.map((e) => SlimTicket.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSlimTicket(): SlimTicket {
  return { threadId: "", ticketId: "", title: "", applianceName: "", applianceId: 0, state: 0, createdAt: 0 };
}

export const SlimTicket: MessageFns<SlimTicket> = {
  encode(message: SlimTicket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    if (message.ticketId !== "") {
      writer.uint32(18).string(message.ticketId);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.applianceName !== "") {
      writer.uint32(34).string(message.applianceName);
    }
    if (message.applianceId !== 0) {
      writer.uint32(40).uint64(message.applianceId);
    }
    if (message.state !== 0) {
      writer.uint32(48).int32(message.state);
    }
    if (message.createdAt !== 0) {
      writer.uint32(56).int64(message.createdAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlimTicket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlimTicket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ticketId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.applianceName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.createdAt = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlimTicket {
    return {
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
      ticketId: isSet(object.ticketId) ? globalThis.String(object.ticketId) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      applianceName: isSet(object.applianceName) ? globalThis.String(object.applianceName) : "",
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      state: isSet(object.state) ? ticketStateFromJSON(object.state) : 0,
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
    };
  },

  toJSON(message: SlimTicket): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.ticketId !== "") {
      obj.ticketId = message.ticketId;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.applianceName !== "") {
      obj.applianceName = message.applianceName;
    }
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.state !== 0) {
      obj.state = ticketStateToJSON(message.state);
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlimTicket>, I>>(base?: I): SlimTicket {
    return SlimTicket.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlimTicket>, I>>(object: I): SlimTicket {
    const message = createBaseSlimTicket();
    message.threadId = object.threadId ?? "";
    message.ticketId = object.ticketId ?? "";
    message.title = object.title ?? "";
    message.applianceName = object.applianceName ?? "";
    message.applianceId = object.applianceId ?? 0;
    message.state = object.state ?? 0;
    message.createdAt = object.createdAt ?? 0;
    return message;
  },
};

function createBaseGetTicketAttachmentDownloadUrlRequest(): GetTicketAttachmentDownloadUrlRequest {
  return { fileId: "", threadId: "" };
}

export const GetTicketAttachmentDownloadUrlRequest: MessageFns<GetTicketAttachmentDownloadUrlRequest> = {
  encode(message: GetTicketAttachmentDownloadUrlRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.threadId !== "") {
      writer.uint32(18).string(message.threadId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTicketAttachmentDownloadUrlRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTicketAttachmentDownloadUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTicketAttachmentDownloadUrlRequest {
    return {
      fileId: isSet(object.fileId) ? globalThis.String(object.fileId) : "",
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
    };
  },

  toJSON(message: GetTicketAttachmentDownloadUrlRequest): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTicketAttachmentDownloadUrlRequest>, I>>(
    base?: I,
  ): GetTicketAttachmentDownloadUrlRequest {
    return GetTicketAttachmentDownloadUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTicketAttachmentDownloadUrlRequest>, I>>(
    object: I,
  ): GetTicketAttachmentDownloadUrlRequest {
    const message = createBaseGetTicketAttachmentDownloadUrlRequest();
    message.fileId = object.fileId ?? "";
    message.threadId = object.threadId ?? "";
    return message;
  },
};

function createBaseGetTicketAttachmentDownloadUrlResponse(): GetTicketAttachmentDownloadUrlResponse {
  return { downloadUrl: "" };
}

export const GetTicketAttachmentDownloadUrlResponse: MessageFns<GetTicketAttachmentDownloadUrlResponse> = {
  encode(message: GetTicketAttachmentDownloadUrlResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.downloadUrl !== "") {
      writer.uint32(10).string(message.downloadUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTicketAttachmentDownloadUrlResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTicketAttachmentDownloadUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.downloadUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTicketAttachmentDownloadUrlResponse {
    return { downloadUrl: isSet(object.downloadUrl) ? globalThis.String(object.downloadUrl) : "" };
  },

  toJSON(message: GetTicketAttachmentDownloadUrlResponse): unknown {
    const obj: any = {};
    if (message.downloadUrl !== "") {
      obj.downloadUrl = message.downloadUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTicketAttachmentDownloadUrlResponse>, I>>(
    base?: I,
  ): GetTicketAttachmentDownloadUrlResponse {
    return GetTicketAttachmentDownloadUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTicketAttachmentDownloadUrlResponse>, I>>(
    object: I,
  ): GetTicketAttachmentDownloadUrlResponse {
    const message = createBaseGetTicketAttachmentDownloadUrlResponse();
    message.downloadUrl = object.downloadUrl ?? "";
    return message;
  },
};

function createBaseVerifyTicketAccessRequest(): VerifyTicketAccessRequest {
  return { threadId: "", applianceIds: [] };
}

export const VerifyTicketAccessRequest: MessageFns<VerifyTicketAccessRequest> = {
  encode(message: VerifyTicketAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    writer.uint32(18).fork();
    for (const v of message.applianceIds) {
      writer.uint64(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyTicketAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyTicketAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.applianceIds.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.applianceIds.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyTicketAccessRequest {
    return {
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
      applianceIds: globalThis.Array.isArray(object?.applianceIds)
        ? object.applianceIds.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: VerifyTicketAccessRequest): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.applianceIds?.length) {
      obj.applianceIds = message.applianceIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyTicketAccessRequest>, I>>(base?: I): VerifyTicketAccessRequest {
    return VerifyTicketAccessRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyTicketAccessRequest>, I>>(object: I): VerifyTicketAccessRequest {
    const message = createBaseVerifyTicketAccessRequest();
    message.threadId = object.threadId ?? "";
    message.applianceIds = object.applianceIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseVerifyTicketAccessResponse(): VerifyTicketAccessResponse {
  return { outcome: 0 };
}

export const VerifyTicketAccessResponse: MessageFns<VerifyTicketAccessResponse> = {
  encode(message: VerifyTicketAccessResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyTicketAccessResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyTicketAccessResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyTicketAccessResponse {
    return { outcome: isSet(object.outcome) ? verifyTicketAccessResponse_OutcomeFromJSON(object.outcome) : 0 };
  },

  toJSON(message: VerifyTicketAccessResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = verifyTicketAccessResponse_OutcomeToJSON(message.outcome);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyTicketAccessResponse>, I>>(base?: I): VerifyTicketAccessResponse {
    return VerifyTicketAccessResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyTicketAccessResponse>, I>>(object: I): VerifyTicketAccessResponse {
    const message = createBaseVerifyTicketAccessResponse();
    message.outcome = object.outcome ?? 0;
    return message;
  },
};

function createBaseAddMessageConversationEntryRequest(): AddMessageConversationEntryRequest {
  return { threadId: "", senderEmail: "", body: "", attachments: [] };
}

export const AddMessageConversationEntryRequest: MessageFns<AddMessageConversationEntryRequest> = {
  encode(message: AddMessageConversationEntryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    if (message.senderEmail !== "") {
      writer.uint32(18).string(message.senderEmail);
    }
    if (message.body !== "") {
      writer.uint32(26).string(message.body);
    }
    for (const v of message.attachments) {
      PreparedTicketAttachment.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMessageConversationEntryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMessageConversationEntryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.senderEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachments.push(PreparedTicketAttachment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMessageConversationEntryRequest {
    return {
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
      senderEmail: isSet(object.senderEmail) ? globalThis.String(object.senderEmail) : "",
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => PreparedTicketAttachment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddMessageConversationEntryRequest): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.senderEmail !== "") {
      obj.senderEmail = message.senderEmail;
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => PreparedTicketAttachment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMessageConversationEntryRequest>, I>>(
    base?: I,
  ): AddMessageConversationEntryRequest {
    return AddMessageConversationEntryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMessageConversationEntryRequest>, I>>(
    object: I,
  ): AddMessageConversationEntryRequest {
    const message = createBaseAddMessageConversationEntryRequest();
    message.threadId = object.threadId ?? "";
    message.senderEmail = object.senderEmail ?? "";
    message.body = object.body ?? "";
    message.attachments = object.attachments?.map((e) => PreparedTicketAttachment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddMessageConversationEntryResponse(): AddMessageConversationEntryResponse {
  return { outcome: 0 };
}

export const AddMessageConversationEntryResponse: MessageFns<AddMessageConversationEntryResponse> = {
  encode(message: AddMessageConversationEntryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMessageConversationEntryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMessageConversationEntryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMessageConversationEntryResponse {
    return { outcome: isSet(object.outcome) ? addMessageConversationEntryResponse_OutcomeFromJSON(object.outcome) : 0 };
  },

  toJSON(message: AddMessageConversationEntryResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = addMessageConversationEntryResponse_OutcomeToJSON(message.outcome);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMessageConversationEntryResponse>, I>>(
    base?: I,
  ): AddMessageConversationEntryResponse {
    return AddMessageConversationEntryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMessageConversationEntryResponse>, I>>(
    object: I,
  ): AddMessageConversationEntryResponse {
    const message = createBaseAddMessageConversationEntryResponse();
    message.outcome = object.outcome ?? 0;
    return message;
  },
};

function createBaseCloseTicketRequest(): CloseTicketRequest {
  return { threadId: "" };
}

export const CloseTicketRequest: MessageFns<CloseTicketRequest> = {
  encode(message: CloseTicketRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseTicketRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseTicketRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseTicketRequest {
    return { threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "" };
  },

  toJSON(message: CloseTicketRequest): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseTicketRequest>, I>>(base?: I): CloseTicketRequest {
    return CloseTicketRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseTicketRequest>, I>>(object: I): CloseTicketRequest {
    const message = createBaseCloseTicketRequest();
    message.threadId = object.threadId ?? "";
    return message;
  },
};

function createBaseCloseTicketResponse(): CloseTicketResponse {
  return { outcome: 0 };
}

export const CloseTicketResponse: MessageFns<CloseTicketResponse> = {
  encode(message: CloseTicketResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseTicketResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseTicketResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseTicketResponse {
    return { outcome: isSet(object.outcome) ? closeTicketResponse_OutcomeFromJSON(object.outcome) : 0 };
  },

  toJSON(message: CloseTicketResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = closeTicketResponse_OutcomeToJSON(message.outcome);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseTicketResponse>, I>>(base?: I): CloseTicketResponse {
    return CloseTicketResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseTicketResponse>, I>>(object: I): CloseTicketResponse {
    const message = createBaseCloseTicketResponse();
    message.outcome = object.outcome ?? 0;
    return message;
  },
};

function createBaseDetailedTicket(): DetailedTicket {
  return {
    threadId: "",
    ticketId: "",
    applianceName: "",
    applianceId: 0,
    title: "",
    state: 0,
    createdAt: 0,
    conversationEntries: [],
  };
}

export const DetailedTicket: MessageFns<DetailedTicket> = {
  encode(message: DetailedTicket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    if (message.ticketId !== "") {
      writer.uint32(18).string(message.ticketId);
    }
    if (message.applianceName !== "") {
      writer.uint32(26).string(message.applianceName);
    }
    if (message.applianceId !== 0) {
      writer.uint32(32).uint64(message.applianceId);
    }
    if (message.title !== "") {
      writer.uint32(42).string(message.title);
    }
    if (message.state !== 0) {
      writer.uint32(48).int32(message.state);
    }
    if (message.createdAt !== 0) {
      writer.uint32(56).int64(message.createdAt);
    }
    for (const v of message.conversationEntries) {
      DetailedTicket_ConversationEntry.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetailedTicket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetailedTicket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ticketId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.applianceName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.createdAt = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.conversationEntries.push(DetailedTicket_ConversationEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetailedTicket {
    return {
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
      ticketId: isSet(object.ticketId) ? globalThis.String(object.ticketId) : "",
      applianceName: isSet(object.applianceName) ? globalThis.String(object.applianceName) : "",
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      state: isSet(object.state) ? ticketStateFromJSON(object.state) : 0,
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      conversationEntries: globalThis.Array.isArray(object?.conversationEntries)
        ? object.conversationEntries.map((e: any) => DetailedTicket_ConversationEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DetailedTicket): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.ticketId !== "") {
      obj.ticketId = message.ticketId;
    }
    if (message.applianceName !== "") {
      obj.applianceName = message.applianceName;
    }
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.state !== 0) {
      obj.state = ticketStateToJSON(message.state);
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.conversationEntries?.length) {
      obj.conversationEntries = message.conversationEntries.map((e) => DetailedTicket_ConversationEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetailedTicket>, I>>(base?: I): DetailedTicket {
    return DetailedTicket.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetailedTicket>, I>>(object: I): DetailedTicket {
    const message = createBaseDetailedTicket();
    message.threadId = object.threadId ?? "";
    message.ticketId = object.ticketId ?? "";
    message.applianceName = object.applianceName ?? "";
    message.applianceId = object.applianceId ?? 0;
    message.title = object.title ?? "";
    message.state = object.state ?? 0;
    message.createdAt = object.createdAt ?? 0;
    message.conversationEntries =
      object.conversationEntries?.map((e) => DetailedTicket_ConversationEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDetailedTicket_ConversationEntry(): DetailedTicket_ConversationEntry {
  return { entry: undefined };
}

export const DetailedTicket_ConversationEntry: MessageFns<DetailedTicket_ConversationEntry> = {
  encode(message: DetailedTicket_ConversationEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.entry?.$case) {
      case "messageConversationEntry":
        DetailedTicket_ConversationEntry_MessageConversationEntry.encode(
          message.entry.messageConversationEntry,
          writer.uint32(10).fork(),
        ).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetailedTicket_ConversationEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetailedTicket_ConversationEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entry = {
            $case: "messageConversationEntry",
            messageConversationEntry: DetailedTicket_ConversationEntry_MessageConversationEntry.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetailedTicket_ConversationEntry {
    return {
      entry: isSet(object.messageConversationEntry)
        ? {
          $case: "messageConversationEntry",
          messageConversationEntry: DetailedTicket_ConversationEntry_MessageConversationEntry.fromJSON(
            object.messageConversationEntry,
          ),
        }
        : undefined,
    };
  },

  toJSON(message: DetailedTicket_ConversationEntry): unknown {
    const obj: any = {};
    if (message.entry?.$case === "messageConversationEntry") {
      obj.messageConversationEntry = DetailedTicket_ConversationEntry_MessageConversationEntry.toJSON(
        message.entry.messageConversationEntry,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetailedTicket_ConversationEntry>, I>>(
    base?: I,
  ): DetailedTicket_ConversationEntry {
    return DetailedTicket_ConversationEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetailedTicket_ConversationEntry>, I>>(
    object: I,
  ): DetailedTicket_ConversationEntry {
    const message = createBaseDetailedTicket_ConversationEntry();
    switch (object.entry?.$case) {
      case "messageConversationEntry": {
        if (object.entry?.messageConversationEntry !== undefined && object.entry?.messageConversationEntry !== null) {
          message.entry = {
            $case: "messageConversationEntry",
            messageConversationEntry: DetailedTicket_ConversationEntry_MessageConversationEntry.fromPartial(
              object.entry.messageConversationEntry,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseDetailedTicket_ConversationEntry_MessageConversationEntry(): DetailedTicket_ConversationEntry_MessageConversationEntry {
  return { text: "", senderEmail: "", senderName: "", attachments: [], direction: 0, createdAt: 0 };
}

export const DetailedTicket_ConversationEntry_MessageConversationEntry: MessageFns<
  DetailedTicket_ConversationEntry_MessageConversationEntry
> = {
  encode(
    message: DetailedTicket_ConversationEntry_MessageConversationEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.senderEmail !== "") {
      writer.uint32(18).string(message.senderEmail);
    }
    if (message.senderName !== "") {
      writer.uint32(26).string(message.senderName);
    }
    for (const v of message.attachments) {
      PersistedTicketAttachment.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.direction !== 0) {
      writer.uint32(40).int32(message.direction);
    }
    if (message.createdAt !== 0) {
      writer.uint32(48).int64(message.createdAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetailedTicket_ConversationEntry_MessageConversationEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetailedTicket_ConversationEntry_MessageConversationEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.senderEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.senderName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachments.push(PersistedTicketAttachment.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.createdAt = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetailedTicket_ConversationEntry_MessageConversationEntry {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      senderEmail: isSet(object.senderEmail) ? globalThis.String(object.senderEmail) : "",
      senderName: isSet(object.senderName) ? globalThis.String(object.senderName) : "",
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => PersistedTicketAttachment.fromJSON(e))
        : [],
      direction: isSet(object.direction) ? detailedTicket_ConversationEntry_DirectionFromJSON(object.direction) : 0,
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
    };
  },

  toJSON(message: DetailedTicket_ConversationEntry_MessageConversationEntry): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.senderEmail !== "") {
      obj.senderEmail = message.senderEmail;
    }
    if (message.senderName !== "") {
      obj.senderName = message.senderName;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => PersistedTicketAttachment.toJSON(e));
    }
    if (message.direction !== 0) {
      obj.direction = detailedTicket_ConversationEntry_DirectionToJSON(message.direction);
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DetailedTicket_ConversationEntry_MessageConversationEntry>, I>>(
    base?: I,
  ): DetailedTicket_ConversationEntry_MessageConversationEntry {
    return DetailedTicket_ConversationEntry_MessageConversationEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DetailedTicket_ConversationEntry_MessageConversationEntry>, I>>(
    object: I,
  ): DetailedTicket_ConversationEntry_MessageConversationEntry {
    const message = createBaseDetailedTicket_ConversationEntry_MessageConversationEntry();
    message.text = object.text ?? "";
    message.senderEmail = object.senderEmail ?? "";
    message.senderName = object.senderName ?? "";
    message.attachments = object.attachments?.map((e) => PersistedTicketAttachment.fromPartial(e)) || [];
    message.direction = object.direction ?? 0;
    message.createdAt = object.createdAt ?? 0;
    return message;
  },
};

function createBaseGetTicketDetailRequest(): GetTicketDetailRequest {
  return { threadId: "" };
}

export const GetTicketDetailRequest: MessageFns<GetTicketDetailRequest> = {
  encode(message: GetTicketDetailRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTicketDetailRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTicketDetailRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTicketDetailRequest {
    return { threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "" };
  },

  toJSON(message: GetTicketDetailRequest): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTicketDetailRequest>, I>>(base?: I): GetTicketDetailRequest {
    return GetTicketDetailRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTicketDetailRequest>, I>>(object: I): GetTicketDetailRequest {
    const message = createBaseGetTicketDetailRequest();
    message.threadId = object.threadId ?? "";
    return message;
  },
};

function createBaseGetTicketDetailResponse(): GetTicketDetailResponse {
  return { outcome: 0, detailedTicket: undefined };
}

export const GetTicketDetailResponse: MessageFns<GetTicketDetailResponse> = {
  encode(message: GetTicketDetailResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.detailedTicket !== undefined) {
      DetailedTicket.encode(message.detailedTicket, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTicketDetailResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTicketDetailResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.detailedTicket = DetailedTicket.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTicketDetailResponse {
    return {
      outcome: isSet(object.outcome) ? getTicketDetailResponse_OutcomeFromJSON(object.outcome) : 0,
      detailedTicket: isSet(object.detailedTicket) ? DetailedTicket.fromJSON(object.detailedTicket) : undefined,
    };
  },

  toJSON(message: GetTicketDetailResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = getTicketDetailResponse_OutcomeToJSON(message.outcome);
    }
    if (message.detailedTicket !== undefined) {
      obj.detailedTicket = DetailedTicket.toJSON(message.detailedTicket);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTicketDetailResponse>, I>>(base?: I): GetTicketDetailResponse {
    return GetTicketDetailResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTicketDetailResponse>, I>>(object: I): GetTicketDetailResponse {
    const message = createBaseGetTicketDetailResponse();
    message.outcome = object.outcome ?? 0;
    message.detailedTicket = (object.detailedTicket !== undefined && object.detailedTicket !== null)
      ? DetailedTicket.fromPartial(object.detailedTicket)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
